import React from 'react';

/** Renders a WFM module icon from `mod.icon`, or a dashed placeholder if missing. */
export default function ModuleIcon({ mod, className = '', size }) {
  const style = size ? { width: size, height: size } : undefined;
  if (mod?.icon) {
    return (
      <img
        src={mod.icon}
        alt=""
        className={className}
        style={style}
        width={size}
        height={size}
        decoding="async"
        aria-hidden="true"
      />
    );
  }
  return <span className={className} style={style} aria-hidden="true" />;
}
